import { z } from "zod";

export const LOCALE_REGEX = `[a-z]{2}(-[A-z]{2})?`;
export const DEFAULT_LOCALE_REGEX = new RegExp(`^${LOCALE_REGEX}$`);
export const LOCALES_REGEX = new RegExp(`^(${LOCALE_REGEX})(, ?(${LOCALE_REGEX}))*$`);

const I18N_SCHEMA = z.object({
  NEXT_PUBLIC_DEFAULT_LOCALE: z.string().regex(DEFAULT_LOCALE_REGEX),
  NEXT_PUBLIC_LOCALES: z.string().regex(LOCALES_REGEX),
  NEXT_PUBLIC_TERRITORY: z.string(),
  NEXT_PUBLIC_LANG_OVERRIDE: z
    .preprocess((val) => (val === "" ? undefined : val), z.string().regex(LOCALES_REGEX).optional())
    .optional(),
});

const i18nEnv = I18N_SCHEMA.parse({
  NEXT_PUBLIC_DEFAULT_LOCALE: process.env.NEXT_PUBLIC_DEFAULT_LOCALE,
  NEXT_PUBLIC_LANG_OVERRIDE: process.env.NEXT_PUBLIC_LANG_OVERRIDE,
  NEXT_PUBLIC_LOCALES: process.env.NEXT_PUBLIC_LOCALES,
  NEXT_PUBLIC_TERRITORY: process.env.NEXT_PUBLIC_TERRITORY,
});

export const i18n = {
  defaultLocale: i18nEnv.NEXT_PUBLIC_DEFAULT_LOCALE,
  locales: i18nEnv.NEXT_PUBLIC_LOCALES.split(",").map((locale) => locale.trim()),
  territory: i18nEnv.NEXT_PUBLIC_TERRITORY,
  langOverride: i18nEnv.NEXT_PUBLIC_LANG_OVERRIDE,
} as const;
